export interface AwMediaQueries {
  query: string | null;
  'sm-min': boolean;
  'md-min': boolean;
  'lg-min': boolean;
  'xl-min': boolean;
  'xs-max': boolean;
  'sm-max': boolean;
  'md-max': boolean;
  'lg-max': boolean;
  'mobile-min': boolean;
  'tablet-min': boolean;
  'desktop-small-min': boolean;
  'desktop-medium-min': boolean;
  'desktop-large-min': boolean;
  'mobile-small-max': boolean;
  'mobile-max': boolean;
  'tablet-max': boolean;
  'desktop-small-max': boolean;
  'desktop-medium-max': boolean;
  initialized: boolean;
}
export const initialMediaQueries: Readonly<AwMediaQueries> = {
  query: null,
  'sm-min': true,
  'md-min': true,
  'lg-min': true,
  'xl-min': true,
  'xs-max': true,
  'sm-max': true,
  'md-max': true,
  'lg-max': true,
  'mobile-min': true,
  'tablet-min': true,
  'desktop-small-min': true,
  'desktop-medium-min': true,
  'desktop-large-min': true,
  'mobile-small-max': true,
  'mobile-max': true,
  'tablet-max': true,
  'desktop-small-max': true,
  'desktop-medium-max': true,
  initialized: false,
};
export interface AwNewMediaQueries {
  smMin: boolean;
  mdMin: boolean;
  lgMin: boolean;
  xlMin: boolean;
  mobileMin: boolean;
  tabletMin: boolean;
  desktopSmallMin: boolean;
  desktopMediumMin: boolean;
  desktopLargeMin: boolean;
  query: string | null;
}
export function transformToMediaQuery (newMediaQueries: AwNewMediaQueries | unknown): Readonly<AwMediaQueries> {
  const nmq = ((typeof newMediaQueries === 'object' && newMediaQueries)
    ? newMediaQueries
    : {}
  ) as AwNewMediaQueries;
  return {
    'sm-min': !!nmq.smMin,
    'md-min': !!nmq.mdMin,
    'lg-min': !!nmq.lgMin,
    'xl-min': !!nmq.xlMin,
    'xs-max': !nmq.smMin,
    'sm-max': !nmq.mdMin,
    'md-max': !nmq.lgMin,
    'lg-max': !nmq.xlMin,
    'mobile-min': !!nmq.mobileMin,
    'tablet-min': !!nmq.tabletMin,
    'desktop-small-min': !!nmq.desktopSmallMin,
    'desktop-medium-min': !!nmq.desktopMediumMin,
    'desktop-large-min': !!nmq.desktopLargeMin,
    'mobile-small-max': !nmq.mobileMin,
    'mobile-max': !nmq.tabletMin,
    'tablet-max': !nmq.desktopSmallMin,
    'desktop-small-max': !nmq.desktopMediumMin,
    'desktop-medium-max': !nmq.desktopLargeMin,
    query: typeof nmq.query === 'string' ? nmq.query : null,
    initialized: true,
  };
}
